import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import IncidentInvestigationPage from '../../modules/itdr/IncidentInvestigation/IncidentInvestigationPage';

export const IncidentInvestigationRouting = (props: LogicalRouteImportProps) => {
    return <LogicalRoute {...props} component={IncidentInvestigationPage} />;
};
